module.exports = __webpack_public_path__ + "static/media/floor-header.13e191c2.jpg";